export default __webpack_public_path__ + "static/media/flag-zimbabwe.694cc4e9.svg";